import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-xs sm:text-sm tracking-[0.25em] uppercase text-sky-600 mb-4">
    {children}
  </p>
);

export const SectionShell = ({ id, testid, children, className = "" }) => (
  <section id={id} data-testid={testid} className={`relative overflow-hidden pt-28 pb-24 sm:pt-32 sm:pb-28 ${className}`}>
    <div className="mx-auto max-w-6xl px-5 sm:px-8">{children}</div>
  </section>
);
